// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__Uj8gR","spinner":"loader_spinner__AwrDw","s3":"loader_s3__n5kgF"};